import { client } from "@/api/client";
import interceptors from "@/api/interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSummaryKomisi(params) {
	return client.get("member/bonus/summary", {
		params: params,
	});
}

function getPotencyKomisi(params) {
	return client.get("member/bonus/potency", {
		params: params,
	});
}

function getHistoryKomisi(params) {
	return client.get("member/bonus/history", {
		params: params,
	});
}

function getHistoryTransfer(params) {
	return client.get("member/bonus/transfer-history", {
		params: params,
	});
}

function getSummaryTransfer(params) {
	return client.get("member/bonus/transfer-summary", {
		params: params,
	});
}

function getDetailUnilevel(params) {
	return client.get("member/bonus/unilevel_detail", {
		params: params,
	});
}

export default {
	getSummaryKomisi,
	getHistoryKomisi,
	getHistoryTransfer,
	getPotencyKomisi,
	getSummaryTransfer,
	getDetailUnilevel
};